export default __webpack_public_path__ + "static/media/hexbetGenericWeb.14c0bfb9.png";